import React, { useRef } from 'react';
import { Typography, Grid } from '@mui/material';
import { Pie } from 'react-chartjs-2';
import { styled } from '@mui/material/styles';
import { Chart, ArcElement, Tooltip, Legend } from 'chart.js';

// Register Chart.js components
Chart.register(ArcElement, Tooltip, Legend);

const Wrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '100%',
  [theme.breakpoints.up('md')]: { width: 'auto' },
}));

export default function PageDistribution({ trees, getChart }) {
  const chartRefs = useRef({});

  return (
    <>
      <Grid container spacing={3} justifyContent="center">
        {trees.map(({ domain, tree, pieChartData }) => {
          const { pieChartData: data, pieChartOptions: options, totalCategories } = getChart(pieChartData, tree.count);
          if (!totalCategories) return null;
          return (
            <Grid item xs={12} md={6} key={domain}>
              <Wrapper>
                <Typography variant="h4" sx={{ mb: 1 }}>
                  {domain} Page Distribution
                </Typography>
                <div style={{ width: '100%', height: 300 }}>
                  <Pie
                    data={data}
                    options={options}
                    ref={(inst) => (chartRefs.current[domain] = inst)}
                  />
                </div>
              </Wrapper>
            </Grid>
          );
        })}
      </Grid>
    </>
  );
}